'use strict';

(function(){

    var app = angular.module('tmx-app', [
        'ngAnimate',
        'ui.router',
        'ngMaterial',
        'ngAria',
        'ngCookies',
        'pascalprecht.translate',
        'kendo.directives',
        'ngMessages',
        'satellizer',
        'ngMdIcons',
        'tmx-configurations',
        'ui.mask',
        'tmx-common',
        'ngMap',
        'ngFileUpload',
        'ngSanitize',
        'ng-currency',
        'angular-uuid'
    ]);
    app.config(['$mdThemingProvider',function($mdThemingProvider) {
           
        var customPrimary = {
            '50': '#6ac7ff',
            '100': '#51bdff',
            '200': '#37b3ff',
            '300': '#1ea9ff',
            '400': '#04a0ff',
            '500': '0091ea',
            '600': '#0081d0',
            '700': '#0071b7',
            '800': '#00629d',
            '900': '#005284',
            'A100': '#84d0ff',
            'A200': '#9ddaff',
            'A400': '#b7e4ff',
            'A700': '#00426a'
        };
        $mdThemingProvider.definePalette('customPrimary', customPrimary);

        var customAccent = {
            '50': '#ebf5e1',
            '100': '#dfeecd',
            '200': '#d3e8ba',
            '300': '#c7e2a7',
            '400': '#badb94',
            '500': '#AED581',
            '600': '#a2cf6e',
            '700': '#95c85b',
            '800': '#89c248',
            '900': '#7cb43c',
            'A100': '#f8fbf4',
            'A200': '#ffffff',
            'A400': '#ffffff',
            'A700': '#6fa136'
        };
        $mdThemingProvider.definePalette('customAccent', customAccent);

        var customWarn = {
            '50': '#f2977a',
            '100': '#f08463',
            '200': '#ee724c',
            '300': '#eb6035',
            '400': '#e94d1d',
            '500': '#D84315',
            '600': '#c13c13',
            '700': '#aa3510',
            '800': '#922d0e',
            '900': '#7b260c',
            'A100': '#f4a992',
            'A200': '#f7bba9',
            'A400': '#f9cec0',
            'A700': '#641f0a'
        };
        $mdThemingProvider.definePalette('customWarn', customWarn);

        var customBackground = {
            '50': '#ffffff',
            '100': '#ffffff',
            '200': '#ffffff',
            '300': '#ffffff',
            '400': '#ffffff',
            '500': '#ffffff',
            '600': '#f2f2f2',
            '700': '#e6e6e6',
            '800': '#d9d9d9',
            '900': '#cccccc',
            'A100': '#ffffff',
            'A200': '#ffffff',
            'A400': '#ffffff',
            'A700': '#bfbfbf'
        };
        $mdThemingProvider.definePalette('customBackground', customBackground);

       //$mdThemingProvider.theme('default')
       //  .primaryPalette('customPrimary')
       //  .accentPalette('customAccent')
       //  .warnPalette('customWarn')
       //  .backgroundPalette('customBackground');
        $mdThemingProvider.theme('default')
            .primaryPalette('customPrimary', {'default' : '500'})
            .accentPalette('customAccent')
            .warnPalette('customWarn', {'default' : '500'})
            .backgroundPalette('customBackground');
    }]);
    app.config(["$sceDelegateProvider", function ($sceDelegateProvider) {
        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            "self",
            // Allow loading from Google maps
            APP_CONSTANTS.blob
        ]);
    }]);
      

    app.config(function(){
        // Date.prototype.toJSON = function(){ 
        //     return moment(this).format('YYYY-MM-DDTHH:mm:ss'); 
        // }
    });

    app.config(['$translateProvider','APP_CONSTANTS',function($translateProvider,APP_CONSTANTS){
        $translateProvider.useSanitizeValueStrategy(null);
        $translateProvider.useStaticFilesLoader({
            prefix: 'assets/locale/',
            suffix: '.json'
        });

        /*$translateProvider.useLocalStorage();*/ //TO DO(Gives injection Error)
        if(localStorage.getItem('culture') == null) {
            $translateProvider.preferredLanguage(APP_CONSTANTS.default_culture);
        }
        else {
            $translateProvider.preferredLanguage(localStorage.getItem('culture'));
        }
        

        localStorage.getItem('culture') == null ?localStorage.setItem('culture',APP_CONSTANTS.default_culture):'';

    }]);

    app.run(['$rootScope', '$location', '$auth','$urlRouter', 'Breadcrumbs','ServerExceptionService','PrevilegeService',
        function ($rootScope, $location, $auth,$urlRouter,Breadcrumbs,ServerExceptionService,PrevilegeService) {

            // eslint-disable-next-line no-unused-vars
            $rootScope.$on('$stateChangeSuccess', function (event, toState,   toParams, fromState, fromParams) {
                Breadcrumbs.generate();
                firebase.logTmxEvent('page_view', { page_title: toState.name });
            });
            $rootScope.$on('$stateChangeSuccess', function() {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            });
            // eslint-disable-next-line no-unused-vars
            $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
               
                if(toParams.token){
                    localStorage.setItem('TMX_access_token',toParams.token);
                    var currentDate = new Date();
                    localStorage.setItem('expires_in', currentDate.setDate(currentDate.getDate + 1));
                }
                ServerExceptionService.Displaymsg = ServerExceptionService.Displayfunction("");//reset Display Message on every state change
                if ($auth.isAuthenticated()) {
                    var authorised = PrevilegeService.CheckStatePrevilege(toState.name);
                    if(!authorised) {
                        event.preventDefault(); return;
                    }
                    if(!toState.name.startsWith('private') && !toState.name.startsWith('frame')) {
                        $location.path("/home/dashboard");
                    }
                  //#region Commented Code
                //   if(angular.isDefined(menu.pages.sections)){
                //       for(var j=0;j<menu.pages.sections.length;j++){
                //           var section  = menu.pages.sections[j];
                //           if(angular.isDefined(section.pages)){
                //               for(var i=0;i<section.pages.length;i++){
                                   
                //                   var Arr = toState.name.split(".");

                //                   if(Arr[2] == section.pages[i].name.toLowerCase()  && angular.isDefined(section.pages[i].disabledEntity) &&
                //                       section.pages[i].disabledEntity){
                //                       event.preventDefault();
                //                   }
                //                   else if(Arr[2] == section.pages[i].name.toLowerCase()  && angular.isDefined(section.pages[i].disabledEntity) &&
                //                       !section.pages[i].disabledEntity){
                //                       //check other privileges
                                       
                //                       if(angular.isDefined(Arr[3]) && angular.isDefined(section.pages[i].privileges)){
                //                           found=false;
                //                           for(var k=0;k<section.pages[i].privileges.length;k++){
                //                               if(Arr[3].toLowerCase()=="add"){Arr[3]="create";}

                //                               if(Arr[3] == section.pages[i].privileges[k].PrivilegeName.toLowerCase()){
                //                                   found=true;
                //                               }
                //                               else if(Arr[3].toLowerCase()=="edit" && section.pages[i].privileges[k].PrivilegeName.toLowerCase()=="view"){
                //                                   found=true;
                //                               }
                //                           }
                                           
                //                           if(!found){ event.preventDefault(); return;}
                //                       }


                //                   }
                //               }
                //           }
                //       }
                //   }

                  //#endregion

                }//authenticated if end
            //   if (!$auth.isAuthenticated()) {
            //        
            //       if(toState.name.startsWith('private'))
            //       {
            //           event.preventDefault();
            //           $rootScope.$evalAsync(function() {
            //               $location.path("/public/login");
            //           });
            //       }
            //   }
            });//rootscope.on end
           
          //for adding authorization token for AJAX calls sent by HTML5 reportviewer for reports
            $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
               
                jqXHR.setRequestHeader("Authorization", "Bearer " + $auth.getToken());
            });


            $urlRouter.listen();
        }]);

})();//final end


